import TonalButton from '@/components/TonalButton';
import { ExitToApp as DisconnectIcon } from '@mui/icons-material';
import { type ButtonProps } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import mediaQuery from '@/lib/styling/mediaQuery';

const StyledButton = styled(TonalButton)({
  [mediaQuery(600)]: {
    marginLeft: 48,
  },
});

type DisconnectAccountButtonProps = Omit<
  ButtonProps,
  'startIcon' | 'loadingPosition' | 'children'
>;

const DisconnectAccountButton = (props: DisconnectAccountButtonProps) => (
  <StyledButton
    startIcon={<DisconnectIcon />}
    loadingPosition="start"
    {...props}
  >
    <FormattedMessage id="portfolio.challenge.files.add.connected_accounts_dialog.account_settings.disconnect_account_button" />
  </StyledButton>
);

export default DisconnectAccountButton;
